import { UncontrolledCheckbox } from '@dreryk/react-components';

import { patientMedicalDocumentRepositoryTranslationKeys } from '../translations';

type MedicalDocumentShowRemovedCheckboxProps = {
   readonly preferRemovedMedicalDocumentVisible: boolean;
   readonly onRemovedMedicalDocumentVisibilityChange: (visible: boolean) => void;
};

export const MedicalDocumentShowRemovedCheckbox = (props: MedicalDocumentShowRemovedCheckboxProps): JSX.Element => (
   <UncontrolledCheckbox
      testId={'removedMedicalDocumentVisibility'}
      name={'removedMedicalDocumentVisibility'}
      id={'removedMedicalDocumentVisibility'}
      label={patientMedicalDocumentRepositoryTranslationKeys.removedVisible}
      selected={props.preferRemovedMedicalDocumentVisible}
      onSelectionChange={props.onRemovedMedicalDocumentVisibilityChange}
   />
);
